/**
 * Modelo de chave para o agente de IA da TME.
 *
 * O Igor (Claude Code numa VPS da escola) tem a PROPRIA chave, so com o que o
 * trabalho dele pede: leads, reabordagens, fichas de aluno, matriculas e
 * contratos. A chave nao herda papel: o que esta aqui e tudo o que o agente
 * ve e faz pelo MCP.
 *
 * Fica de fora: excluir qualquer coisa, conferir ficha (so a Jaque confirma
 * a ficha do aluno) e usuarios, papeis, modulos, configuracoes ou
 * integracoes.chaves, para o agente nunca ampliar o proprio acesso.
 *
 * O modelo so preenche o formulario. Quem cria confere e pode ajustar.
 */
export type PerfilAgente = {
  readonly id: string;
  readonly nome: string;
  readonly papel: string;
  readonly escopos: readonly string[];
};

export const PERFIS_AGENTES: readonly PerfilAgente[] = [
  {
    id: 'igor',
    nome: 'Igor',
    papel: 'Agente de IA da TME: leads, reabordagens, fichas de aluno, matriculas e contratos',
    escopos: [
      'pessoas.ver', 'pessoas.criar', 'pessoas.editar',
      'leads.ver', 'leads.criar', 'leads.editar', 'leads.importar',
      'turmas.ver', 'turmas.matricular',
      'contratos.ver', 'contratos.gerar', 'contratos.enviar', 'contratos.anexar',
      'comercial.ver', 'comercial.criar', 'comercial.editar', 'comercial.concluir',
    ],
  },
];
